import React from 'react'

/**
 * Single site-wide footer for all v2 pages. Keep in sync with v2.css
 * under `.version-v2 > footer.v2-footer` only.
 */
const SiteFooter = () => {
    return (
        <footer className="v2-footer" role="contentinfo">
            <p>
                © {new Date().getFullYear()} Precision Fluid Controls, Inc.&nbsp; · &nbsp;
                1751 Aviation Blvd, Suite 100, Lincoln, CA 95648
            </p>
        </footer>
    )
}

export default SiteFooter
